import { SITE_TITLE, SITE_TITLE_SEPARATOR } from "../data/constants/site";

export default function setActiveTitle(activeTitle) {
  if (!activeTitle || activeTitle === SITE_TITLE) {
    document.title = SITE_TITLE;
  } else if (!!activeTitle) {
    document.title = `${activeTitle}${SITE_TITLE_SEPARATOR}${SITE_TITLE}`;
  }
}
